import { Container, Stack, Text, Box, Flex, Badge } from "@chakra-ui/react";
import React from "react";
import { withTranslation } from "react-i18next";
import { FiFileText, FiUsers, FiBookOpen } from "react-icons/fi";
import { GiTeacher } from "react-icons/gi";
import { RiFileCopy2Line, RiGraduationCapLine } from "react-icons/ri";

const RecordesComp = ({ t }) => {
  const data = [
    {
      icon: <FiUsers fontSize="32px" color="#FF8C00" />,
      title: t("components.records.title_1") || "المتابعة الدورية",
      desc: t("components.records.desc_1") || "متابعة الطالب لمنع تراكم الحصص",
      color: "orange.500",
      bgColor: "orange.50"
    },
    {
      icon: <FiBookOpen fontSize="32px" color="#FF8C00" />,
      title: t("components.records.title_2") || "امتحانات وتدريبات",
      desc: t("components.records.desc_2") || "امتحانات دوريه لتدريب الطالب على امتحان اخر السنة",
      color: "orange.500",
      bgColor: "orange.50"
    },
    {
      icon: <RiFileCopy2Line fontSize="32px" color="#FF8C00" />,
      title: t("components.records.title_3") || "اكبر بنك اسئلة",
      desc: t("components.records.desc_3") || "اكبر بنك اسئله في جميع المواد من جميع المصادر",
      color: "orange.500",
      bgColor: "orange.50"
    },
  ];
  return (
    <Box bg="gray.50" w="100%" py={16}>
      <Container maxW={"container.xl"} my={16}>
        <Flex direction="column" align="center" mb={12}>
          <Flex align="center" gap={3} mb={4}>
            <Box
              p={3}
              bg="orange.50"
              borderRadius="full"
              color="orange.500"
            >
              <RiGraduationCapLine fontSize="24px" />
            </Box>
            <Text
              textAlign="center"
              fontWeight="700"
              fontSize={{ base: "24px", md: "32px" }}
              color="gray.800"
              fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
            >
              {t("components.records.title") || "مميزات المنصه لتسهيل دراستك"}
            </Text>
          </Flex>
        </Flex>

        <Stack flexDir="row" flexWrap="wrap" gap={6} mt={8}>
          {data?.map((elem, index) => {
            return (
              <Stack
                bg="white"
                borderRadius="24px"
                align="center"
                key={index}
                py="60px"
                px="40px"
                w={{ base: "100%", md: "32%" }}
                textAlign="center"
                boxShadow="0 15px 35px rgba(0,0,0,0.08)"
                border="1px solid"
                borderColor="gray.200"
                transition="all 0.4s ease"
                _hover={{
                  transform: "translateY(-12px)",
                  boxShadow: "0 25px 50px rgba(0,0,0,0.15)",
                  borderColor: "orange.200"
                }}
                position="relative"
                overflow="hidden"
                minH="280px"
                justify="center"
              >
                {/* Background decoration */}
                <Box
                  position="absolute"
                  top="-30px"
                  right="-30px"
                  w="120px"
                  h="120px"
                  bg="orange.50"
                  borderRadius="full"
                  opacity="0.1"
                />
                
                <Box
                  p={5}
                  bg={elem.bgColor}
                  borderRadius="20px"
                  mb={6}
                  border="2px solid"
                  borderColor="orange.100"
                  boxShadow="0 4px 15px rgba(255, 140, 0, 0.1)"
                >
                  {elem?.icon}
                </Box>

                <Text 
                  fontSize="22px" 
                  fontWeight="800" 
                  fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif" 
                  color="gray.800" 
                  mb={4}
                  lineHeight="1.3"
                >
                  {elem?.title}
                </Text>
                <Text 
                  color="gray.600" 
                  fontSize="16px" 
                  fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif" 
                  lineHeight="1.7"
                  maxW="250px"
                >
                  {elem?.desc}
                </Text>
              </Stack>
            );
          })}
        </Stack>
      </Container>
    </Box>
  );
};

export default withTranslation()(RecordesComp);
